var React = require('react');

function LogoP5jsOriginal (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#ED225D","strokeMiterlimit":"10","d":"M16.909,10.259l8.533-2.576l1.676,5.156l-8.498,2.899l5.275,7.48\r\n\tl-4.447,3.225l-5.553-7.348L8.487,26.25l-4.318-3.289l5.275-7.223L0.88,12.647l1.678-5.16l8.598,2.771V1.364h5.754V10.259z"}));
}

LogoP5jsOriginal.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = LogoP5jsOriginal;

LogoP5jsOriginal.default = LogoP5jsOriginal;
